import FJSlider from '../FJSlider/FJSlider';
import FJToolTip from '../FJToolTip/FJToolTip';
import styles from './FJFitBox.module.less';
import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore';
import FJZoomIcon from '../../../assets/svg/timeline-zoom-.svg?react';
import FJZoomAddIcon from '../../../assets/svg/timeline-zoom+.svg?react';

const FJFitBox = props => {
    const {
        maxZoom,
        minZoom,
        zoom,
        step = 0.1,

        zoomOutDisabled,
        zoomInDisabled,
        disableFitButton,
        fitOnClickHandler,
        disableSlider,

        onChangeZoom,
        placement = 'bottom',
    } = props;

    return (
        <div className={classNames(styles.fit_box)}>
            <FJToolTip title='image-extender-zoom-out' placement={placement}>
                <div
                    className={classNames(styles.fit_icon_box, {
                        [styles.disabled]: zoomOutDisabled,
                    })}
                    onClick={() => !zoomOutDisabled && onChangeZoom(Math.max(zoom - step, minZoom))}
                >
                    <FJZoomIcon className={styles.fit_icon} />
                </div>
            </FJToolTip>
            <FJSlider
                className={classNames(styles.fit_slider, { [styles.disabled]: disableSlider })}
                max={maxZoom}
                min={minZoom}
                value={zoom}
                disabled={disableSlider}
                onChange={onChangeZoom}
            />
            <FJToolTip title='image-extender-zoom-in' placement={placement}>
                <div
                    className={classNames(styles.fit_icon_box, {
                        [styles.disabled]: zoomInDisabled,
                    })}
                    onClick={() => !zoomInDisabled && onChangeZoom(Math.min(zoom + step, maxZoom))}
                >
                    <FJZoomAddIcon className={styles.fit_icon} />
                </div>
            </FJToolTip>
            <div
                className={classNames(styles.fit_btn, {
                    [styles.disabled]: disableFitButton,
                })}
                onClick={disableFitButton ? () => {} : fitOnClickHandler}
            >
                {FJLocalStore._('fit')}
            </div>
        </div>
    );
};

export default FJFitBox;
